// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AdvancedEditorController from "./advanced_editor_controller";
application.register("advanced-editor", AdvancedEditorController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import Bridge__AlertController from "./bridge/alert_controller";
application.register("bridge--alert", Bridge__AlertController);

import Bridge__ButtonController from "./bridge/button_controller";
application.register("bridge--button", Bridge__ButtonController);

import Bridge__MenuController from "./bridge/menu_controller";
application.register("bridge--menu", Bridge__MenuController);

import Bridge__RecordController from "./bridge/record_controller";
application.register("bridge--record", Bridge__RecordController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import DragDropController from "./drag_drop_controller";
application.register("drag-drop", DragDropController);

import Embed__BridgeController from "./embed/bridge_controller";
application.register("embed--bridge", Embed__BridgeController);

import Embed__PrepareFormController from "./embed/prepare_form_controller";
application.register("embed--prepare-form", Embed__PrepareFormController);

import Embed__RecorderController from "./embed/recorder_controller";
application.register("embed--recorder", Embed__RecorderController);

import EnableSubmitController from "./enable_submit_controller";
application.register("enable-submit", EnableSubmitController);

import HotkeyController from "./hotkey_controller";
application.register("hotkey", HotkeyController);

import FaqController from "./faq_controller";
application.register("faq", FaqController);

import PhoneModalController from "./phone_modal_controller";
application.register("phone-modal", PhoneModalController);

import PhoneShareController from "./phone_share_controller";
application.register("phone-share", PhoneShareController);

import PreviewTemplateController from "./preview_template_controller";
application.register("preview-template", PreviewTemplateController);

import ResizeController from "./resize_controller";
application.register("resize", ResizeController);

import SlimController from "./slim_controller";
application.register("slim", SlimController);

import SortController from "./sort_controller";
application.register("sort", SortController);

import StoreAudio__PipController from "./store_audio/pip_controller";
application.register("store-audio--pip", StoreAudio__PipController);

import StoreAudio__RecorderController from "./store_audio/recorder_controller";
application.register("store-audio--recorder", StoreAudio__RecorderController);

import StoreAudio__RecordingController from "./store_audio/recording_controller";
application.register("store-audio--recording", StoreAudio__RecordingController);

import StoreAudio__ScreenLockerController from "./store_audio/screen_locker_controller";
application.register("store-audio--screen-locker", StoreAudio__ScreenLockerController);

import StoreAudio__ScreenModifierController from "./store_audio/screen_modifier_controller";
application.register("store-audio--screen-modifier", StoreAudio__ScreenModifierController);

import StoreAudio__TextModifierController from "./store_audio/text_modifier_controller";
application.register("store-audio--text-modifier", StoreAudio__TextModifierController);

import StoreAudio__TimerController from "./store_audio/timer_controller";
application.register("store-audio--timer", StoreAudio__TimerController);

import StoreAudio__TranscriptController from "./store_audio/transcript_controller";
application.register("store-audio--transcript", StoreAudio__TranscriptController);

import StoreAudio__VisualizerController from "./store_audio/visualizer_controller";
application.register("store-audio--visualizer", StoreAudio__VisualizerController);

import StyleViaDataController from "./style_via_data_controller";
application.register("style-via-data", StyleViaDataController);

import SwipeoutController from "./swipeout_controller";
application.register("swipeout", SwipeoutController);

import ViewScrollController from "./view_scroll_controller";
application.register("view-scroll", ViewScrollController);
